<li [tabindex]="ttTabIndex" class="tt-side-nav-item" (keydown)="$event.key === 'Enter' || $event.key === ' ' ? this.onClick($event) : null" (click)="onClick($event)">
    <span *ngIf="expandable" class="tt-side-nav-item__button-expand" (click)="toggleExpansion($event)">
        <span class="fa-fw far tt-side-nav-item__button-expand-icon" [ngClass]="ttExpanded ? 'fa-chevron-down' : 'fa-chevron-right'"></span>
    </span>
    <span *ngIf="!expandable" style="font-size: var(--tt-font-size); min-width: calc(1.25em + 0.8rem)"> </span>
    <button
        tabindex="-1"
        class="tt-side-nav-item__link"
        [matTooltip]="ttText"
        [matTooltipShowDelay]="(sideNav.open$ | async) ? 1000 : 0"
        matTooltipHideDelay="0"
        [matTooltipPosition]="(sideNav.open$ | async) ? 'below' : 'right'"
        matTooltipClass="tt-side-nav-item__link--tooltip"
        [style.--tt-side-nav-item-color]="ttIconColor"
    >
        <span class="fa-fw fad" [ngClass]="ttIcon" [style.color]="ttIconColor"></span>
        <span class="tt-sidenav__text">
            {{ ttText }}
        </span>
    </button>
</li>

<ul [hidden]="!expandable" [ngClass]="{ 'tt-side-nav-item__children--expanded': ttExpanded }" class="tt-side-nav-item__children" style="overflow: hidden">
    <ng-content></ng-content>
</ul>
